module.exports = __webpack_public_path__ + "media/img/icons/check-icon-009c3de1f568b943ca916e5a0e4e10e8.svg";